import ErrorLogoHurt from './error-logo-hurt';
export default ErrorLogoHurt;
